import {DeclarativeMutationConfig, Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {CreateDeliverableInput, CreateDeliverableMutation} from './__generated__/CreateDeliverableMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

const mutation = graphql`
	mutation CreateDeliverableMutation($input: CreateDeliverableInput!) {
		createDeliverable(input: $input) {
			deliverable {
				node {
					id
					name
					description
					price
					invoicedAmount
				}
			}
		}
	}
`;

function getConfigs(input): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.projectId,
			connectionInfo: [
				{
					key: 'Project_deliverables',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'deliverable',
		},
	];
}

function commit(
	environment: Environment,
	input: MutationInput<CreateDeliverableInput>,
	onSuccess?: RelayOnCompleted<CreateDeliverableMutation>,
	onError?: RelayOnError
): Disposable {
	trackEvent('Deliverable', 'Created', input);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
